import React, { createContext, useReducer } from 'react';

const initialState = {};
const fittingRecommendationsContext = createContext(initialState);
const { Provider } = fittingRecommendationsContext;

const FittingRecommendationsProvider = ({ children }) => {
  const [state, dispatch] = useReducer((contextState, action) => {
    const typeOptions = {
      SET_RECOMMENDATIONS_AND_PROFILE: {
        ...contextState,
        fittingRecommendations: action.fittingRecommendations,
        userProfile: action.userProfile,
        fullBagJson: action.fullBagJson,
        lastUpdatedDate: action.lastUpdatedDate,
      },
    };

    if (typeOptions[action.type]) {
      return typeOptions[action.type];
    }

    throw new Error();
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { fittingRecommendationsContext, FittingRecommendationsProvider };
